import React from 'react';
import { Search, MapPin } from 'lucide-react';
import { Button } from '../ui/Button';
export function HeroSection() {
  return <div className="relative overflow-hidden bg-brand-charcoal text-white pt-24 pb-32 px-4 sm:px-6 lg:px-8" data-id="element-236">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-237">
        <div className="absolute -top-1/2 -right-1/4 w-[1000px] h-[1000px] rounded-full bg-gradient-to-br from-brand-amber/20 to-transparent blur-3xl" data-id="element-238" />
        <div className="absolute -bottom-1/2 -left-1/4 w-[800px] h-[800px] rounded-full bg-gradient-to-tr from-brand-amber/10 to-transparent blur-3xl" data-id="element-239" />
      </div>

      <div className="relative max-w-4xl mx-auto text-center z-10" data-id="element-240">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight mb-6 leading-tight" data-id="element-241">
          El marketplace gastronómico de{' '}
          <span className="text-brand-amber" data-id="element-242">Los Santos</span>
        </h1>
        <p className="text-lg sm:text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-243">
          Descubre, ordena y disfruta de los mejores restaurantes de la zona en
          un solo lugar.
        </p>

        {/* Search Bar */}
        <div className="bg-white p-2 rounded-2xl sm:rounded-full shadow-xl max-w-3xl mx-auto flex flex-col sm:flex-row items-center gap-2" data-id="element-244">
          <div className="flex-1 w-full flex items-center px-4 py-2 border-b sm:border-b-0 sm:border-r border-gray-100" data-id="element-245">
            <MapPin className="w-5 h-5 text-gray-400 mr-3 shrink-0" data-id="element-246" />
            <select className="w-full bg-transparent text-gray-900 focus:outline-none appearance-none cursor-pointer font-medium" data-id="element-247">
              <option value="" data-id="element-248">Todas las zonas</option>
              <option value="san-marcos" data-id="element-249">San Marcos</option>
              <option value="santa-maria" data-id="element-250">Santa María</option>
              <option value="dota" data-id="element-251">Dota</option>
            </select>
          </div>

          <div className="flex-1 w-full flex items-center px-4 py-2" data-id="element-252">
            <Search className="w-5 h-5 text-gray-400 mr-3 shrink-0" data-id="element-253" />
            <input type="text" placeholder="¿Qué se te antoja hoy?" className="w-full bg-transparent text-gray-900 focus:outline-none placeholder:text-gray-400" data-id="element-254" />
          </div>

          <Button size="lg" className="w-full sm:w-auto rounded-xl sm:rounded-full px-8 shrink-0" data-id="element-255">
            Buscar
          </Button>
        </div>
      </div>
    </div>;
}